import React, { useState } from "react";
import SaberMasButton from "../../../components/SaberMasBtn/SaberMasBtn";
import CarouselControls from "../../CarouselControls/CarouselControls";
import "./ServicesSection.css";
import backgroundImage1 from "./service11.jpg";
import backgroundImage2 from "./service2.png";
import backgroundImage3 from "./service33.jpg";
import panelImage1 from "./service1.png";
import panelImage2 from "./service2.png";
import panelImage3 from "./service3.jpg";

const ServicesSection = () => {
  const [currentPanel, setCurrentPanel] = useState(0);
  const [transitionDirection, setTransitionDirection] = useState('next');

  const panels = [
    {
      image: panelImage1,
      background: backgroundImage1,
      title: "Paneles Solares",
      description: "Nuestros servicios",
      saberMasLink: "/servicios/0"
    },
    {
      image: panelImage2,
      background: backgroundImage2,
      title: "Promoción Inmobiliaria",
      description: "Nuestros servicios",
      saberMasLink: "/servicios/1"
    },
    {
      image: panelImage3,
      background: backgroundImage3,
      title: "Obra Civil y Edificación",
      description: "Nuestros servicios",
      saberMasLink: "/servicios/2"
    }
  ];

  const getPanelOrder = () => {
    const order = [];
    for (let i = 0; i < panels.length; i++) {
      const index = (currentPanel + i) % panels.length;
      order.push(panels[index]);
    }
    return order;
  };

  const nextPanel = () => {
    setTransitionDirection('next');
    setCurrentPanel((prev) => (prev === panels.length - 1 ? 0 : prev + 1));
  };

  const prevPanel = () => {
    setTransitionDirection('prev');
    setCurrentPanel((prev) => (prev === 0 ? panels.length - 1 : prev - 1));
  };

  const goToPanel = (index) => {
    setTransitionDirection(index > currentPanel ? 'next' : 'prev');
    setCurrentPanel(index);
  };

  return (
    <section
      className="services-section hero-section"
      style={{ backgroundImage: `url(${panels[currentPanel].background})` }}
    >
      <div className="services-content-container">
        <div className="home-text services-content">
          <p>Nuestros servicios</p>
          <h1>{panels[currentPanel].title}</h1>
          <p>
            {currentPanel === 0 && "Instalamos plantas solares fotovoltaicas personalizadas, con el sistema PEG, para suelos y cubiertas con tecnología avanzada."}
            {currentPanel === 1 && "Desarrollamos proyectos inmobiliarios sostenibles con integración de energías renovables y diseño eficiente."}
            {currentPanel === 2 && "Ejecutamos obras civiles con los más altos estándares de calidad y sostenibilidad ambiental."}
          </p>
          <SaberMasButton variant="hero" to={panels[currentPanel].saberMasLink} context="hero" />
        </div>

        <div className="panels-component">
          <div className="panels-container">
            <div className={`panels-wrapper ${transitionDirection}`}>
              {getPanelOrder().map((panel, index) => (
                <div
                  key={`${panel.title}-${index}`}
                  className={`right-panel position-${index}`}
                  style={{ backgroundImage: `url(${panel.image})` }}
                >
                  <div className="right-panel-content">
                    <p>{panel.description}</p>
                    <h2>{panel.title}</h2>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
    
<div className="carousel-controls-container">
  <CarouselControls
    totalSlides={panels.length}
    currentSlide={currentPanel}
    onNext={nextPanel}
    onPrev={prevPanel}
    onDotClick={goToPanel}
    variant="dots"
    autoPlay={true}
    position="absolute"
  />
</div>
      </div>
    </section>
  );
};

export default ServicesSection;